import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './Field.module.scss'

export default function Field({ children, className, error }: props) {
  return (
    <div className={classNames('Field', styles.this, !!error && styles.error, className)}>
      {children}
      {typeof error === 'string' &&
        <div uk-alert="true" className={classNames(styles['this--validation'], 'uk-alert-danger')}>
          {error}
        </div>
      }
    </div>
  )
}

Field.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}



// WEBPACK FOOTER //
// ./src/components/Field/Field.js